/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.throttle"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var propTypes = {
  onMouseDown: _propTypes.default.func.isRequired,
  onTouchStart: _propTypes.default.func.isRequired,
  resizeHandleClassName: _propTypes.default.string.isRequired
};
var ColumnResizer = function (_Component) {
  (0, _inherits2.default)(ColumnResizer, _Component);
  var _super = _createSuper(ColumnResizer);
  function ColumnResizer(props) {
    var _this;
    (0, _classCallCheck2.default)(this, ColumnResizer);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "domRef", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "overHeight", 0);
    _this.state = {
      over: false
    };
    _this.domRef = _react.default.createRef();
    _this.onMouseDown = _this.onMouseDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.onTouchStart = _this.onTouchStart.bind((0, _assertThisInitialized2.default)(_this));
    _this.onMouseEnter = _this.onMouseEnter.bind((0, _assertThisInitialized2.default)(_this));
    _this.onMouseLeave = _this.onMouseLeave.bind((0, _assertThisInitialized2.default)(_this));
    _this.setOver = (0, _lodash.default)(_this.setOver, 50, {
      leading: false
    });
    return _this;
  }
  (0, _createClass2.default)(ColumnResizer, [{
    key: "onMouseEnter",
    value: function onMouseEnter() {
      var parent = this.domRef.current.parentElement;
      var overHeight = parent ? parent.offsetHeight : null;
      this.overHeight = overHeight;
      this.setOver(true);
    }
  }, {
    key: "setOver",
    value: function setOver(value) {
      if (value) {
        this.setState({
          over: true,
          overHeight: this.overHeight
        });
      } else {
        this.setState({
          over: false
        });
      }
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.setOver(false);
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(event) {
      event.preventDefault();
      if (this.props.onMouseDown) {
        this.props.onMouseDown(event);
      }
      this.setState({
        over: false
      });
    }
  }, {
    key: "onTouchStart",
    value: function onTouchStart(event) {
      event.preventDefault();
      if (this.props.onTouchStart) {
        this.props.onTouchStart(event);
      }
      this.setState({
        over: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var _this$props = this.props,
        className = _this$props.className,
        resizeHandleClassName = _this$props.resizeHandleClassName;
      var style = _objectSpread(_objectSpread({}, props.style), {}, {
        height: this.state.overHeight
      });
      var resizeHandleStyle = _objectSpread({}, props.resizeHandleStyle);
      if (this.state.over) {
        resizeHandleStyle.visibility = 'visible';
      } else {
        resizeHandleStyle.visibility = 'hidden';
      }
      return _react.default.createElement("div", {
        ref: this.domRef,
        draggable: "false",
        className: className,
        onMouseDown: this.onMouseDown,
        onTouchStart: this.onTouchStart,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        style: style
      }, _react.default.createElement("div", {
        style: resizeHandleStyle,
        className: resizeHandleClassName
      }));
    }
  }]);
  return ColumnResizer;
}(_react.Component);
exports.default = ColumnResizer;
(0, _defineProperty2.default)(ColumnResizer, "propTypes", propTypes);


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/Layout/ColumnLayout/Cell/ColumnResizer.js
// module id = 209
// module chunks = 0